var CollectionView, NoteView, NotesView, template, _ref,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

CollectionView = require('./base/collection-view');

NoteView = require('./note-view');

template = require('./templates/notes');

module.exports = NotesView = (function(_super) {
  __extends(NotesView, _super);

  function NotesView() {
    this.changeActivePage = __bind(this.changeActivePage, this);
    this.getNotesForPage = __bind(this.getNotesForPage, this);
    this.filterer = __bind(this.filterer, this);
    _ref = NotesView.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  NotesView.prototype.template = template;

  NotesView.prototype.itemView = NoteView;

  NotesView.prototype.autoRender = true;

  NotesView.prototype.listSelector = '#notes-list';

  NotesView.prototype.itemSelector = '.item';

  NotesView.prototype.currentPage = [];

  NotesView.prototype.listen = {
    'catalogue:pageTurned mediator': 'changeActivePage',
    'reset collection': 'notesUpdate',
    'notes:update mediator': 'notesUpdate',
    'notes:getForPage mediator': 'getNotesForPage'
  };

  NotesView.prototype.initialize = function() {
    return NotesView.__super__.initialize.apply(this, arguments);
  };

  NotesView.prototype.filterer = function(model) {
    var pageNumber;
    pageNumber = parseInt(model.get("page_num"));
    return -1 !== this.currentPage.indexOf(pageNumber);
  };

  NotesView.prototype.getNotesForPage = function(page) {
    this.currentPage = page;
    return this.renderAllItems();
  };

  NotesView.prototype.changeActivePage = function(activePage) {
    this.getNotesForPage(activePage);
    return false;
  };

  NotesView.prototype.notesUpdate = function() {
    return this.publishEvent('catalogue:getActivePage', this.getNotesForPage);
  };

  return NotesView;

})(CollectionView);
